import { render } from "./MyEventDetail.vue?vue&type=template&id=1e74534e&scoped=true"
import script from "./MyEventDetail.vue?vue&type=script&lang=js"
export * from "./MyEventDetail.vue?vue&type=script&lang=js"

import "./MyEventDetail.vue?vue&type=style&index=0&id=1e74534e&lang=scss&scoped=true"

import exportComponent from "/var/www/development/hai-parahita-dev.aksamedia.co.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e74534e"]])

export default __exports__